import soloPracticeCostImage from "@/assets/blog-solo-practice-cost-hero.jpg";
import practiceManagerImage from "@/assets/blog-practice-manager-hero.jpg";
import enquiryConversionImage from "@/assets/case-study-conversion-hero.jpg";
import dentalRecoveryImage from "@/assets/case-study-dental-recovery-hero.jpg";

export interface CaseStudy {
  slug: string;
  image: string;
  category: string;
  date: string;
  title: string;
  listingTitle?: string;
  excerpt: string;
  author: string;
  readTime: string;
}

export const caseStudies: CaseStudy[] = [
  {
    slug: "/case-studies/dental-practice-no-show-recovery",
    image: dentalRecoveryImage,
    category: "Healthcare",
    date: "September 2026",
    title: "The practice that was bleeding £6,200 a month without knowing it",
    listingTitle: "A practice was losing £6,200 a month without knowing it. Here is what changed.",
    excerpt:
      "The practice manager guessed six or seven unfilled appointments a week. The actual number was eighteen. Here is what we built and what four months of data showed.",
    author: "Ayomide Oke",
    readTime: "6 min read",
  },
  {
    slug: "/case-studies/22-to-58-enquiry-conversion",
    image: enquiryConversionImage,
    category: "Healthcare",
    date: "September 2026",
    title: "Two clinics were losing patients to nothing but the clock",
    listingTitle: "Two clinics were losing patients to nothing but the clock",
    excerpt:
      "Two thirds of enquiries arrived after 6pm. The average response time was 14 hours and 40 minutes. Here is what happened when we reduced that to 90 seconds.",
    author: "Ayomide Oke",
    readTime: "6 min read",
  },
  {
    slug: "/case-studies/practice-manager-would-not-let-go",
    image: practiceManagerImage,
    category: "Healthcare",
    date: "September 2026",
    title: "The practice manager who would not let go",
    listingTitle: "The practice manager who would not let go",
    excerpt:
      "We were brought in to make a private physio practice more efficient. The practice manager showed us we were about to build the wrong thing. Here is what she taught us and what we built instead.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/case-studies/single-handed-practice-real-cost",
    image: soloPracticeCostImage,
    category: "Healthcare",
    date: "August 2026",
    title: "What running a practice alone actually costs",
    listingTitle: "What the smallest practice we worked with taught us.",
    excerpt:
      "One doctor, one part-time assistant, and a practice held together entirely by one person's memory and willingness to never fully switch off. Here is what we built and what changed when she finally took a week off for the first time in two years.",
    author: "Ayomide Oke",
    readTime: "7 min read",
  },
];
